import React from "react";
import BroadcastForm from "components/broadcasts/BroadcastForm";
import Broadcast from "entities/broadcast";
import { withRouter } from "react-router-dom";
import makeValidable from "core/components/Validable";

const ValidableBroadcastForm = makeValidable(BroadcastForm);

class BroadcastEditPage extends React.Component {
    constructor(props) {
        super(props);
        this.validableRef = React.createRef();
        this.state = {
            broadcast: Broadcast.getDefaultInput(),
            submitting: false,
            showValidations: false,
            recipients: [],
            loading: true
        };

        this.navigateBack = this.navigateBack.bind(this);
    }

    async componentDidMount() {
        this.setState({
            recipients: await Broadcast.getRecipients(),
            loading: false
        });
    }

    send = () => {
        this.setState({ showValidations: true }, async () => {
            if (this.validableRef.current.isValid()) {
                this.setState({ submitting: true });
                try {
                    await Broadcast.create(this.state.broadcast);
                    this.props.history.push("/broadcasts");
                }
                catch (error) {
                    console.error(error);
                    this.setState({ submitting: false });
                }
            };
        });
    };

    navigateBack = () => {
        this.props.history.push("/broadcasts");
    };

    render() {
        const { showValidations, broadcast, submitting, loading, recipients } = this.state;

        return (
            <ValidableBroadcastForm
                ref={this.validableRef}
                showValidations={showValidations}
                broadcast={broadcast}
                onSubmit={this.send}
                onCancel={this.navigateBack}
                onBroadcastUpdated={broadcast => this.setState({ broadcast })}
                submitting={submitting}
                recipients={recipients}
                loading={loading}
            />
        );
    }
}

export default withRouter(BroadcastEditPage);
